import Slider, { SliderProps } from '@mui/material/Slider';

export type HorizontalSliderProps = SliderProps;

export const HorizontalSlider = (props: HorizontalSliderProps): JSX.Element => {
  return <Slider valueLabelDisplay="auto" {...props} />;
};
